var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"is-size-7 has-margin-bottom-100"},[_vm._v("\n    "+_vm._s(_vm.$t("_sentence.complete_registration_msg"))+"\n  ")]),_vm._v(" "),_c('set-password-form')],1)}
var staticRenderFns = []

export { render, staticRenderFns }